import React, {PropTypes} from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import ArrowForward from 'material-ui/svg-icons/navigation/arrow-forward';
import {Link} from 'react-router';

export default function FoundationOverviewDescription({children, name, title, characterId, pictogramItem, pictogramText}) {
  return (
    <div className="foundation-overview-description">
      <div className="header"><strong>{name}</strong>&nbsp;/&nbsp;{title}</div>
      <div className="subheader">{pictogramItem}</div>
      <div className="body">{pictogramText}</div>
      <div>
        <RaisedButton
          className="raised-button--rounded"
          label="Go To Lessons"
          labelPosition="before"
          primary
          containerElement={<Link to={`/detail/${characterId}`} />}
          icon={<ArrowForward />} />
      </div>
    </div>
  );
}

FoundationOverviewDescription.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
  name: PropTypes.string,
  title: PropTypes.string,
  characterId: PropTypes.number,
  pictogramItem: PropTypes.string,
  pictogramText: PropTypes.string,
};



// WEBPACK FOOTER //
// ./app/features/dashboard/components/FoundationOverviewDescription.js